import React from 'react';
import { motion } from 'framer-motion';

const Services = () => {
  return (
    <div className="services" style={{ paddingTop: '100px', minHeight: '80vh' }}>
      <div className="container">
        <div className="section">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Nuestros Servicios</h1>
            <p>Página en construcción...</p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Services;
